import React, { Component } from 'react';
import { withTheme, withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { withFeatureFlags } from '../../../../../../userProfile/featureFlagsContext';
import { MapAutoZoom, MapLegendToggle, Resize, Popout } from '../../../../../../layout/layoutHeader/components';
import DrawingToolbox from '../../../../../mapComponents/Drawing/DrawingToolbox';
import constants from '../../../../../../appConstants';
import WatchTutorial from '../../../../../InAppTutorial/WatchTutorial';
import { CustomMenu } from '../../../../../common/MUI';
import { ToggleAnchorPoints } from '../ShowAnchorPoints/components';
import { observer, inject } from 'mobx-react';
import PrintMenu from '../../../../../../layout/layoutHeader/printComponent';

const ROUTE_MAP_CONTROLS = {
  MAP_LEGEND: 'isMapLegendEnabled',
  ROUTE_ANIMATION: 'isRouteAnimationEnabled', 
  ANCHOR_POINTS: 'isToggleAnchorPointsEnabled'
};

const styles = (theme) => ({
  toggledMenu: {
    display: 'inline'
  },
  headerIconStyles: {
    display: 'inline-flex',
    alignItems: 'center',
    '& > *:first-child': {
      borderLeft: 'none !important'
    }
  },
  printIcon: {
    cursor: 'pointer',
    padding: '10px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    float: 'left',
    color: theme.iconColor,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  }
});

@inject('IBPlanningStore')
@observer
class RouteMapHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMaximised: false
    };
  }

  componentDidMount() {
    this.props.stack.on('maximised', this.onMaximise);
    this.props.stack.on('minimised', this.onMinimise);
    this.setState({
      isMaximised: this.props.stack.isMaximised
    });
  }

  componentWillUnmount() {
    this.props.stack.off('maximised', this.onMaximise);
    this.props.stack.off('minimised', this.onMinimise);
  }

  onMaximise = () => {
    this.setState({
      isMaximised: true
    });
  };

  onMinimise = () => {
    this.setState({
      isMaximised: false
    });
  };

  onAfterPrint = () => {
    this.props.stack.layoutManager.eventHub.emit('afterPrintEvent');
  };

  toggleRouteMapControl = (settingName) => () => {
    this.props.IBPlanningStore.updateRouteMapControls(settingName);
  };

  render() {
    const { classes, theme, IBPlanningStore, ...other } = this.props;
    const { routeMapControls } = IBPlanningStore;

    return (
      <div className={classes.headerIconStyles}>
        <DrawingToolbox measureTool lasso delete />
        {this.state.isMaximised && (
          <div className={classes.printIcon}>
            <PrintMenu
              stack={this.props.stack}
              featureFlags={this.props.featureFlags.featureFlags}
              onAfterPrint={this.onAfterPrint}
              eventHub={this.props.stack.layoutManager.eventHub}
            />
          </div>
        )}
        <Resize {...other} />
        <Popout {...other} />
        <div className={classes.toggledMenu}>
          <CustomMenu
            classes={classes}
            menuContent={
              <>
                <WatchTutorial showLabel componentId={constants.mapName.RoutesMap} />
                <MapAutoZoom
                  isEnabled={routeMapControls.isRouteAnimationEnabled}
                  isMenuItem
                  toggleRouteAnimation={this.toggleRouteMapControl(ROUTE_MAP_CONTROLS.ROUTE_ANIMATION)}
                  eventHub={this.props.stack.layoutManager.eventHub}
                  title={`${routeMapControls.isRouteAnimationEnabled ? 'Disable' : 'Enable'} Auto Zoom`}
                  {...other}
                />
                <MapLegendToggle
                  isMapLegendEnabled={routeMapControls.isMapLegendEnabled}
                  isMenuItem
                  toggleMapLegend={this.toggleRouteMapControl(ROUTE_MAP_CONTROLS.MAP_LEGEND)}
                  {...other}
                />
                <ToggleAnchorPoints
                  isMenuItem
                  isEnabled={routeMapControls.isToggleAnchorPointsEnabled}
                  toggleAnchorPoints={this.toggleRouteMapControl(ROUTE_MAP_CONTROLS.ANCHOR_POINTS)}
                  {...other}
                />
              </>
            }
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withUserProfile,
  withTheme(),
  withStyles(styles),
  withFeatureFlags
)(RouteMapHeader);
